import { baseApi } from "../baseApi";

export const revokeAffiliationApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    revokeAffiliation: build.mutation<
      any,
      | { token: string }
      | { adultId: string; youthId: string; isDisabled?: boolean }
    >({
      query: (request) => {
        if ("token" in request) {
          return {
            url: "/youth/contacts/revoke",
            method: "POST",
            body: { token: request.token },
          };
        }
        const { adultId, youthId, isDisabled } = request;
        const baseUrl = `/adult/affiliation/revoke/${adultId}/${youthId}`;
        const url =
          isDisabled !== undefined
            ? `${baseUrl}?is_disabled=${isDisabled}`
            : baseUrl;
        return {
          url,
          method: "POST",
        };
      },
    }),
  }),
});

export const { useRevokeAffiliationMutation } = revokeAffiliationApi;
